"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeight = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OuterElementContext = /*#__PURE__*/(0, _react.createContext)({});

// eslint-disable-next-line react/display-name
const OuterElementType = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const outerProps = (0, _react.useContext)(OuterElementContext);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref
  }, props, outerProps));
});
const getHeight = (itemCount, itemSize, itemData, itemsToShow) => {
  if (itemCount > itemsToShow) {
    return itemsToShow * itemSize;
  }
  return itemData.map(() => itemSize).reduce((a, b) => a + b, 0);
};

// Adapter for react-window
exports.getHeight = getHeight;
const Listbox = /*#__PURE__*/(0, _react.forwardRef)(function ListboxComponent(props, ref) {
  const {
    className,
    children,
    itemSize = 48,
    itemsToShow = 8,
    overscanCount = 5,
    ...other
  } = props;
  const classes = (0, _index.default)();
  const itemData = _react.default.Children.toArray(children);
  const itemCount = itemData.length;
  const renderRow = rowProps => {
    const {
      data,
      index,
      style
    } = rowProps;
    return /*#__PURE__*/(0, _react.cloneElement)(data[index], {
      style: {
        ...style,
        top: style.top
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.listBox, className),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(OuterElementContext.Provider, {
    value: other
  }, /*#__PURE__*/_react.default.createElement(_reactWindow.VariableSizeList, {
    itemData: itemData,
    height: getHeight(itemCount, itemSize, itemData, itemsToShow),
    key: itemCount,
    outerElementType: OuterElementType,
    innerElementType: "ul",
    itemSize: () => itemSize,
    overscanCount: overscanCount,
    itemCount: itemCount
  }, renderRow)));
});
var _default = exports.default = Listbox;